
function Header() {
    return (

        <div className='flex-col justify-centre m-16 p-6  rounded-2xl bg-slate-900'>
            <h1 className='text-white text-center font-extrabold sm:text-2xl text-1xl uppercase'>
                Count-Reset App
            </h1>
        </div>

    )
}

export default Header;